import script from "./my-employee-payslips.vue?vue&type=script&setup=true&lang=js"
export * from "./my-employee-payslips.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__